
import PlayLists from '../../components/meeting/leftsidebar/playList';
import { meetingModel } from '../../models/meetingModel';
import { Types } from '../action/action';

const initialState = {
  currentWindowState: 'mainPage',
  meetingList: [],
  videoRecordingList: [],
  getRecordListInput: {
    offset: 0,
    limit: 10,
    search: ""
  },
  logs: [],
  isLeftBarLoading: false,
  templateListLoader: false,
  getListInput: {
    offset: 0,
    limit: 10,
    filter: "Upcoming",
    searchText: "",
    sort: "1"
  },
  detailPage: {},
  templateDetailPage: {},
  meetingListByDate: [],
  filterDate: "",
  templateList: [],
  meetingTotalCount: {},
  getTemplateListInput: {
    offset: 0,
    limit: 20,
    sort: -1,
    sortType: "date"
  },
  storeTemplateListSortValue: {},
  currentMeetingDetailPage: {},
  previousMeetingDetailPage: {},
  originalMOM: [],
  editMOM: "",
  editMOMCopy: "",
  editSummaryState: false,
  part_MOM: [],
  momLoad: true,
  keywords: [],
  transcript: [],
  transcriptLoad: true,
  transcriptCount: 0,
  actionsData: [],
  actionsLoad: true,
  actionsCount: 0,
  performanceData: [],
  performanceLoad: true,
  performanceCount: 0,
  ccToast: false,
  ccMessage: "",
  ccTab: "1",
  meetingHighlights: [],
  searchKey: "",
  currenthomeState: '',
  recordDetailPage: [],
  recShare: false,
  recCount: 0,
  recLoad: false,
  ringStatus: false,
  meetingCountStatus: false,
  playLists:[],
  playListsPage:[],
  clips:[],
  updatePlayList:[],
  planBased:[]
  // detailPage:{calender_type: "None",
  //   description: "",
  //   dial_in_countries: [],
  //   duration_minutes: 0,
  //   end_timestamp: 0,
  //   files: [],
  //   invite_url: "",
  //   is_alternate_host: false,
  //   is_attended: 0,
  //   is_cancelled: 0,
  //   is_custom_password: false,
  //   is_host_myvideo: false,
  //   is_participant_invite_guest: false,
  //   is_participant_join_bef_host: false,
  //   is_participant_mute_entry: false,
  //   is_participant_video: false,
  //   is_participant_waiting_room: false,
  //   is_record_meeting: false,
  //   is_use_personal_meeting_id: false,
  //   is_without_host_continue: false,
  //   joining_option_type: "",
  //   meeting_id: "",
  //   participants: [],
  //   password: "",
  //   personal_meeting_id: "",
  //   rrule: "",
  //   save_template: true,
  //   sip_id: "",
  //   start_timestamp: 0,
  //   status: "",
  //   timezone: "",
  //   title: "",
  //   uuid: ""}

};

export const meetingReducer = (state: meetingModel = initialState, action: any) => {
  let {
    type,
    payload
  } = action;
  switch (type) {
    case Types.MEETING_WINDOW_STATE:
      return {
        ...state, currentWindowState: payload.currentWindowState
      };
    case Types.MEETING_HOME_STATE:
      return {
        ...state, currenthomeState: payload.currenthomeState
      };

    case Types.MEETING_LEFT_SIDE:
      return {
        ...state, meetingList: payload.meetingList, isLeftBarLoading: false
      };
    case Types.VIDEO_RECORDING_LIST:
      return {
        ...state, videoRecordingList: payload.videoRecordingList, recCount: payload.recCount, recLoad: payload.recLoad
      };
    case Types.LEFT_SIDE_LOADER:
      return {
        ...state, isLeftBarLoading: payload.isLeftBarLoading
      };
    case Types.SAVED_TEMPLATE_LOADER:
      return {
        ...state, templateListLoader: payload.templateListLoader
      };
    case Types.MEETING_DETAIL_PAGE:
      return {
        ...state, detailPage: payload.detailPage
      };
    case Types.STORE_MEETING_LIST_INPUT:
      return {
        ...state, getListInput: payload.getListInput
      };
    case Types.STORE_VIDEORECORDING_LIST_INPUT:
      return {
        ...state, getRecordListInput: payload.getRecordListInput
      };
    case Types.TEMPLATE_DETAIL_PAGE:
      return {
        ...state, templateDetailPage: payload
      };
    case Types.MEETING_CALENDAR_LIST:
      return {
        ...state, meetingListByDate: payload.meetingListByDate, filterDate: payload.filterDate
      };
    case Types.STORE_TEMPLATE_LIST_INPUT:
      return {
        ...state, getTemplateListInput: payload.getTemplateListInput
      };
    case Types.TEMPLATE_LIST:
      return {
        ...state, templateList: payload
      };
    case Types.STORE_SORT_TEMPLATE_LIST_INPUT:
      return {
        ...state, storeTemplateListSortValue: payload
      };
    case Types.MEETING_DETAIL_CURRENT_PAGE:
      return {
        ...state, currentMeetingDetailPage: payload
      };
    case Types.MEETING_DETAIL_PREVIOUS_PAGE:
      return {
        ...state, previousMeetingDetailPage: payload
      };
    case Types.MEETING_TOTAL_COUNT:
      return {
        ...state, meetingTotalCount: payload
      };
    case Types.MOM_PAGE:
      return {
        ...state, originalMOM: payload.originalMOM, momLoad: payload.momLoad, part_MOM: payload.part_MOM, keywords: payload.keywords
      }

    case Types.EDIT_MOM: {
      return {
        ...state, editMOM: payload.editMOM, editMOMCopy: payload.editMOMCopy, editSummaryState: payload.editSummaryState
      }
    }
    case Types.TRANSCRIPT_PAGE:
      return {
        ...state, transcript: payload.transcript, transcriptLoad: payload.transcriptLoad, transcriptCount: payload.transcriptCount
      }
    case Types.ACTIONS_PAGE:
      return {
        ...state, actionsData: payload.actionsData, actionsLoad: payload.actionsLoad, actionsCount: payload.actionsCount
      }

    case Types.PERFORMANCE_PAGE:
      return {
        ...state, performanceData: payload.performanceData, performanceLoad: payload.performanceLoad, performanceCount: payload.performanceCount
      }

    case Types.CC_TOAST:
      return {
        ...state, ccToast: payload.ccToast, ccMessage: payload.ccMessage
      }
    case Types.CC_TAB:
      return {
        ...state, ccTab: payload.ccTab
      }
    case Types.HIGHLIGHT_PAGE:
      return {
        ...state, meetingHighlights: payload.meetingHighlights
      }
    case Types.CC:
      return {
        ...state, searchKey: payload.searchKey
      }
    case Types.RECORD_DETAIL_PAGE:
      return {
        ...state, recordDetailPage: payload.recordDetailPage
      }
    case Types.VIDEOMEET_COUNT_STATUS:
      return {
        ...state, meetingCountStatus: payload.meetingCountStatus
      }
    case Types.REC_SHARE:
      return {
        ...state, shareDetails: payload.shareDetails, recShare: payload.recShare
      }
    case Types.VIDEOCALL_RING_STATUS:
      return {
        ...state, ringStatus: payload.ringStatus
      }
    case Types.CLIPS_LIST:
      return {
        ...state, clips: payload.clips
      }
    case Types.PLAY_LIST:
      return {
        ...state, playLists: payload?.playLists
      }
      case Types.PLAY_LIST_PAGE:
      return {
        ...state, playListsPage: payload?.playListsPage
      }
      case Types.UPDATE_PLAYLIST:
       return {
        ...state, updatePlayList: payload?.update_data
      }
      case Types.PLAN_BASED_FEATURE:
        return {
         ...state, planBased: payload?.planBased
       }
    default:
      return state;
  }
};